import axios from 'axios'

// 创建一个axios的实例
const Axios = axios.create({
  baseURL: `https://aip.baidubce.com`, 
  timeout: 50000 * 2, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
	'Accept': 'application/json'
  }
})

// 添加请求拦截
Axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config.headers['Authorization'] = 'Bearer bce-v3/ALTAK-K0Wkz1wwjSpfICsVsOqwP/ec0865f3622d21a03f0fed79161c6337c7122fae'
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
Axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log('响应拦截错误',error.message);
    return Promise.reject(error)
  }
)

export default Axios